import React, { useRef } from 'react';
import { Button, Menu, useMediaQuery, useTheme } from '@mui/material';

import { useModal } from '../../lib';
import { Icon } from '../Icon';
import icons from '../Icon/icons';

export interface MenuItemsProps<T> {
  onSelect: (value: T) => void;
}

interface SelectorProps<T> {
  MenuItems: React.FC<MenuItemsProps<T>>;
  onSelect: (value: T) => void;
  selectedIcon?: keyof typeof icons;
  selectedText?: string;
  menuProps: any;
}

export const Selector = <T,>({ MenuItems, onSelect, selectedIcon, selectedText, menuProps }: SelectorProps<T>) => {
  const [isSelectorOpen, onOpenSelector, onCloseSelector] = useModal(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const popoverRef = useRef(null);

  const onItemSelect = async (value: any) => {
    onSelect(value);
    onCloseSelector();
  };

  return (
    <>
      <Button
        ref={popoverRef}
        variant="outlined"
        onClick={onOpenSelector}
        endIcon={<Icon type="arrow-down" width={10} />}
        startIcon={selectedIcon && <Icon type={selectedIcon} />}
        sx={{
          [theme.breakpoints.down('sm')]: {
            p: 1.25,
            width: 67,
            '.MuiButton-startIcon': { ml: 0, mr: 1 },
            '.MuiButton-endIcon': { mx: 0 },
          },
        }}
      >
        {!isSmallScreen && selectedText}
      </Button>
      <Menu anchorEl={popoverRef.current} open={isSelectorOpen} onClose={onCloseSelector} {...menuProps}>
        <MenuItems onSelect={onItemSelect} />
      </Menu>
    </>
  );
};
